'use strict';

import $ from 'jquery';
import doT from 'dot';

import hotSearchTpl from '../../tpl/hot-search.html.js';
import lxWrap from '../../common/js/lx'
import lxBid from '../../common/js/lx-bid'

/**
 * 渲染热搜模块
 * @param {*} config 
 * @param {*} result 
 * @param {*} container 
 */
const renderHotWords = (config, list, container) => {
        let data = {};
        data.records = list.slice(0, config.SHOW_NUM) || [];
        data.cityId = config.cityId;
        data.cateId = config.channelId || 0;
        data.domain = config.domain;

        let tempFn = doT.template(hotSearchTpl);
        let resultText = tempFn(data);
        container.empty();
        $(resultText).appendTo(container);
        // 热搜词点击点
        lxWrap($('.hot-search a'), lxBid.hotWordsBid, false, false)
}

/**
 * 热搜词模块
 * @param {*} config 
 */
const hotSearchData = (config) => {

    let hotSearch = config.container.find('.J-hot-search');
    if (hotSearch && hotSearch.length > 0) { 
        let cityId = config.cityId || '1',
        cateId = config.channelId || '0',
        recordList = []

        // TODO 
        // 热搜词，如果是首页，大搜页，调首页的热搜词，是子频道，调子频道热搜词
        if(config.isIndexPage || config.isSearchPage) {
            $.ajax({
                type: 'get',
                url: `/bar/search?cityId=${cityId}`,
                success: function (result) {
                    if(result && result.code == '200' && result.recordList.length > 0){
                        recordList = result.recordList
                        renderHotWords(config, recordList, hotSearch)
                    }
                },
                error: function (e) {
                    console.log(`首页热搜词请求失败${e}`)
                }
            });
        }else{
            $.ajax({
                type: 'get',
                url: `/bar/search/categoryhotword?cityId=${cityId}&bu=${cateId}`,
                success: function (result) {
                    if(result && result.code == '200' && result.recordList.length > 0){
                        renderHotWords(config, result.recordList, hotSearch)
                    }
                },
                error: function (e) {
                    console.log(`业务线热搜词请求失败${e}`)
                    if (recordList.length > 0) { 
                        renderHotWords(config, recordList, hotSearch)
                    }

                }
            });
        }
    }
    
}

export default {
    init: (config) => {
        // 首页
        if (config.isIndexPage || config.isSearchPage) {
            config.channelId = 0;
        }
        hotSearchData(config)

    }
}



// WEBPACK FOOTER //
// ./modules/logo-input/js/hot-search.js